module.exports = __webpack_public_path__ + "img/tabco.acedf138.png";